import { palette } from '../global/palette';
import { typography } from '../global/typography';
import type { ComponentOverride } from '../types';

export const MuiLink: ComponentOverride<'MuiLink'> = {
  MuiLink: {
    styleOverrides: {
      root: {
        ...typography.body1,
        color: palette.common.black,
        textDecorationColor: 'inherit',
        '&:visited': {
          color: palette.common.black,
        },
        '&:hover': {
          color: palette.primary.light,
        },
        '&:focus': {
          color: palette.primary.dark,
          outlineOffset: 3,
        },
        '&:active': {
          color: palette.primary.dark,
          outlineOffset: 3,
        },
      },
    },
  },
};
